import { Component, OnInit, OnDestroy} from '@angular/core'
import { trigger, state, transition, style, animate } from '@angular/animations'
import { ViewService } from '../shared';
import { Subscription } from 'rxjs';
import { AlertMessage } from '../model/alert-message';
import { fade, popUp } from '../shared/animations'

@Component({
    selector: 'alert',
    template: require('./alert.component.html'),
    styles: [require('./alert.component.scss')],
    animations: [fade, popUp]
})

export class AlertComponent implements OnInit, OnDestroy {

    private show = false;
    private alert: AlertMessage;
    private subscription: Subscription = null;

    constructor(private viewService: ViewService) {}

    get stateName() {
        return this.show ? 'show' : 'hide';
    }

    private toggle() {
        this.show = !this.show;
    }

    update(alert: AlertMessage) {
        this.alert = alert;
        if (!this.show && alert.text !== '') {
            this.toggle();
        }
    }

    ngOnInit() {
        this.subscription = this.viewService.getMessage().subscribe((a) => {
            this.update(a);
        });
    }

    ngOnDestroy() {
        if (this.subscription) {
            this.subscription.unsubscribe();
        }
    }
}
